import React from 'react';
import PropTypes from 'prop-types';
import Typewriter from 'typewriter-effect';
import Search from './search';
import searchIndices from './search-indices';
import {
  Container, IntroText,
} from './search-animated-intro-css';

const SearchAnimatedIntro = ({ introText, placeholders }) => (
  <Container>
    <IntroText>
      <Typewriter
        options={{
          cursor: '',
          delay: 40,
        }}
        onInit={(typewriter) => {
          introText.forEach((text) => {
            typewriter.typeString(text).pauseFor(500);
          });
          typewriter.start();
        }}
      />
    </IntroText>
    <Search collapse indices={searchIndices} placeholders={placeholders} />
  </Container>
);

SearchAnimatedIntro.propTypes = {
  introText: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholders: PropTypes.arrayOf(PropTypes.string),
};
SearchAnimatedIntro.defaultProps = {
  placeholders: null,
};

export default SearchAnimatedIntro;
